module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/vip6-5bc0ad951028c9feb55830fd0368826c.png";